/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailStorageStatsFoldersInner
 */
export interface EmailStorageStatsFoldersInner {
    /**
     * 
     * @type {string}
     * @memberof EmailStorageStatsFoldersInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailStorageStatsFoldersInner
     */
    displayName?: string;
    /**
     * 
     * @type {number}
     * @memberof EmailStorageStatsFoldersInner
     */
    totalItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EmailStorageStatsFoldersInner
     */
    unreadItemCount?: number;
    /**
     * 
     * @type {number}
     * @memberof EmailStorageStatsFoldersInner
     */
    sizeInBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof EmailStorageStatsFoldersInner
     */
    sizeMB?: string;
}

/**
 * Check if a given object implements the EmailStorageStatsFoldersInner interface.
 */
export function instanceOfEmailStorageStatsFoldersInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EmailStorageStatsFoldersInnerFromJSON(json: any): EmailStorageStatsFoldersInner {
    return EmailStorageStatsFoldersInnerFromJSONTyped(json, false);
}

export function EmailStorageStatsFoldersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailStorageStatsFoldersInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'totalItemCount': !exists(json, 'totalItemCount') ? undefined : json['totalItemCount'],
        'unreadItemCount': !exists(json, 'unreadItemCount') ? undefined : json['unreadItemCount'],
        'sizeInBytes': !exists(json, 'sizeInBytes') ? undefined : json['sizeInBytes'],
        'sizeMB': !exists(json, 'sizeMB') ? undefined : json['sizeMB'],
    };
}

export function EmailStorageStatsFoldersInnerToJSON(value?: EmailStorageStatsFoldersInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'displayName': value.displayName,
        'totalItemCount': value.totalItemCount,
        'unreadItemCount': value.unreadItemCount,
        'sizeInBytes': value.sizeInBytes,
        'sizeMB': value.sizeMB,
    };
}

